import { Injectable } from '@angular/core';
import { BaseCadouhApiService } from '../../../shared/services/base-cadouh-api.service';
import { VendorDetails } from '../models/vendor-details';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingsApiService extends BaseCadouhApiService {

  getVendorDetails(): Observable<VendorDetails> {
  return this.http.get<VendorDetails>(`${this.baseUrl}/giftshop/admin/vendor_settings/`,{ headers: this.getRequestHeadersWithToken()});
  }

  updateVendorDetails(vendorDetails: VendorDetails): Observable<VendorDetails> {
    return this.http.patch<VendorDetails>(`${this.baseUrl}/giftshop/admin/vendor_settings/`, vendorDetails, { headers: this.getRequestHeadersWithToken() });
  }


}
